import * as _ from 'lodash';

angular.module("tromanWeb").controller('WageGroupHistoryController', ['tromanServer', 'dialogService', 'downloadService', 'reportService', 'wageGroupShared', function (tromanServer, dialogService, downloadService, reportService, wageGroupShared) {
    this.$onInit = function $onInit() {
        this.wageGroup = wageGroupShared.wageGroup;
        tromanServer.PaymentRounds
            .search({ WageGroupId: this.wageGroup.Id })
            .then(x => {
                this.history = _.drop(_.orderBy(x, y => y.RoundNumber, "desc"), 1);
            })
            .catch(dialogService.error);
    };

    this.canDownloadFile = function canDownloadFile(round) {
        return round != null && round.HasTransactionData;
    };

    this.downloadFile = function downloadFile(round) {
        tromanServer.PaymentRounds
            .downloadFile(round)
            .then(rsp => downloadService.downloadBlob(rsp.blob, rsp.filename))
            .catch(dialogService.error);
    };

    this.canDownloadReport = function canDownloadReport(round) {
        return round != null && round.HasTransactionData;
    };

    this.downloadReport = function downloadReport(round) {
        var pars = {
            Options: { Format: 1 },
            Query: { PaymentRoundId: round.Id }
        };

        reportService
            .generate('Attestation', pars)
            .then(rsp => downloadService.downloadBlob(rsp.blob, rsp.filename))
            .catch(dialogService.error);
    };
}]);

